module.exports = __webpack_public_path__ + "static/media/loader1.4ec0a481.gif";